import type { ClientData, WindowsFields, GateFields } from '../types/wizard.types';
import { sumGateBreakdown } from './gateAmounts';
import { sumKpBreakdown, sumPodryadBreakdown, sumUnitedBreakdown } from './windowsAmounts';

export function isEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

export function isPhone(s: string): boolean {
  const d = s.replace(/\D/g, '');
  return d.length === 11;
}

export function isValidClient(c: ClientData): boolean {
  return (
    c.fullName.trim().length >= 3 &&
    c.passportSeries.replace(/\D/g, '').length === 4 &&
    c.passportNumber.replace(/\D/g, '').length === 6 &&
    c.passportIssuedBy.trim().length >= 3 &&
    /^\d{4}-\d{2}-\d{2}$/.test(c.passportIssuedDate) &&
    c.registeredAddress.trim().length >= 5 &&
    isPhone(c.phone) &&
    isEmail(c.email)
  );
}

export function isValidUnitedWindows(w: WindowsFields): boolean {
  const hasNum = (s: string) => s.trim() !== '' && Number(s.replace(/\s/g, '').replace(',', '.')) >= 0;
  return (
    w.contractNumber.trim().length > 0 &&
    /^\d{4}-\d{2}-\d{2}$/.test(w.contractDate) &&
    sumUnitedBreakdown(w) > 0 &&
    hasNum(w.prepaymentAmount) &&
    /^\d{4}-\d{2}-\d{2}$/.test(w.prepaymentDueDate) &&
    w.installationAddress.trim().length >= 5
  );
}

export function isValidPodryadPrepayment(w: WindowsFields): boolean {
  if (w.podryadPrepaymentMode !== 'custom') return true;
  const amount = Number(w.podryadPrepaymentAmount.replace(/\s/g, '').replace(',', '.'));
  return w.podryadPrepaymentAmount.trim() !== '' && Number.isFinite(amount)
    && amount >= 0 && amount <= Math.round(sumPodryadBreakdown(w) * 100) / 100;
}

export function isValidWindows(w: WindowsFields): boolean {
  const hasNum = (s: string) => s.trim() !== '' && Number(s.replace(/\s/g, '').replace(',', '.')) >= 0;
  return (
    w.contractNumber.trim().length > 0 &&
    /^\d{4}-\d{2}-\d{2}$/.test(w.contractDate) &&
    sumKpBreakdown(w) > 0 &&
    sumPodryadBreakdown(w) > 0 &&
    isValidPodryadPrepayment(w) &&
    hasNum(w.prepaymentAmount) &&
    /^\d{4}-\d{2}-\d{2}$/.test(w.prepaymentDueDate) &&
    w.installationAddress.trim().length >= 5
  );
}

export function isValidGate(g: GateFields): boolean {
  return (
    g.contractNumber.trim().length > 0 &&
    /^\d{4}-\d{2}-\d{2}$/.test(g.contractDate) &&
    sumGateBreakdown(g) > 0 &&
    /^\d{4}-\d{2}-\d{2}$/.test(g.prepaymentDueDate) &&
    g.installationAddress.trim().length >= 5
  );
}
